import { ShowPromocode } from './show-promocode';

export default ShowPromocode;